import React from "react";
import Container from "@/components/marketing/Container";
import { ExternalLink } from "lucide-react";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

const DEFAULT_SAMPLES = [
  { outlet: "Yahoo Finance", title: "Sample article headline", url: "#" },
  { outlet: "MarketWatch", title: "Sample article headline", url: "#" },
  { outlet: "Gulf News", title: "Sample article headline", url: "#" },
];

export default function SamplePlacements({ samples = DEFAULT_SAMPLES, tag = "PROOF", title = "See real placements", subtitle = "Examples of articles we have placed on named publications." }) {
  return (
    <section className="py-7 sm:py-9 lg:py-12">
      <Container>
        <Reveal>
          <SectionHeading tag={tag} title={title} subtitle={subtitle} />
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[22px] max-w-5xl mx-auto">
          {samples.map((sample, index) => (
            <Reveal variant="card" delay={index * 0.08} key={sample.outlet}>
              <a
                href={sample.url}
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card block p-7 lg:p-8 transition-all group"
                style={{ borderRadius: 20 }}
              >
              <span className="inline-block text-[10px] font-semibold uppercase tracking-[0.12em] text-[#8e8e96] mb-4 px-2 py-1 rounded-md bg-[rgba(28,28,32,0.04)]">{sample.outlet}</span>
              <h3 className="font-heading text-lg font-[650] text-[#1c1c20] mb-4 group-hover:text-[#7c3aed] transition-colors">
                {sample.title}
              </h3>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#7c3aed]">
                View live article <ExternalLink className="w-4 h-4" />
              </span>
              </a>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}